export default "/fonts/vendor/@fontsource/fraunces/files/fraunces-vietnamese-300-normal.woff2?25054651deac1424b8cbe99010e26b32";